function parseSogCog(sogCog) {
    if (!sogCog) {
        return {
            sog: null,
            cog: null,
        };
    }
    const [sog, cog] = sogCog.split('/');
    return { sog, cog };
}
function isValid(sog, cog) {
    const parsedSog = parseFloat(sog);
    const parsedCog = parseFloat(cog);
    return 0 <= parsedSog && parsedSog <= 80 && 0 <= parsedCog && parsedCog <= 360;
}
function sogCogToString(sogCog) {
    if (sogCog.sog && sogCog.cog) {
        if (!isValid(sogCog.sog, sogCog.cog)) {
            return false;
        }
        return `${sogCog.sog}/${sogCog.cog}`;
    }
    else if (sogCog.sog || sogCog.cog) {
        return false;
    }
    return undefined;
}
function format(sogCog) {
    const { sog, cog } = parseSogCog(sogCog);
    const sogString = sog ? `${sog}kn` : '';
    const cogString = cog ? formatCogToThreeDigit(cog) : '';
    return `${sogString} / ${cogString}`;
}
function formatCogToThreeDigit(cog) {
    for (let x = cog.split('.')[0].length; x < 3; x++) {
        cog = `0${cog}`;
    }
    return `${cog}°`;
}
export default {
    parseSogCog,
    sogCogToString,
    format,
};
//# sourceMappingURL=SogCogTransformer.js.map